/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteRsaDevice$Params {

/**
 * Id of a resource.
 */
  id: string;

/**
 * delete device connected to specified branch.
 */
  branch_id: string;
}

export function deleteRsaDevice(http: HttpClient, rootUrl: string, params: DeleteRsaDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteRsaDevice.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.query('branch_id', params.branch_id, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteRsaDevice.PATH = '/api/v1/rsa/devices/{id}';
